import React from 'react'

function Branding() {
  return (
  <section className="bg-gray-100">
    <div className="max-w-screen-xl	mx-auto text-center">
      <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-start justify-between py-10 px-0">
        <div className="w-full flex flex-col justify-center items-center">
          <div className="content px-20">
            <p className="text-left font-bold text-2xl">
              Branding
            </p>
            <p className="text-left text-lg text-gray-600">
              As part of my freelance work for the agency, they also get me to do the branding logo of the product. The client provided the exact color that I will use. The client advised getting inspired by the brand logo of Doordash also highlight the D and S initials on the logo.
            </p>
          </div>
        </div>
      </div>
      <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-center justify-between py-10 px-0">
        <div className="lg:w-1/3 md:w-4/12 sm:w-full flex flex-row justify-around items-center">
          <img src={require('../../common/images/drapshop/dshape.svg')} alt="E Shape Art" />
          <div className="text-left">
            <p className="font-bold">D shape</p>
            <p className="text-sm text-gray-500">Means <em>"drap"</em></p>
          </div>
        </div>
        <div className="lg:w-1/3 md:w-4/12 sm:w-full flex flex-row justify-center items-center">
          <div className="pr-5">
            <p className="text-blue-600 text-xl font-bold">+</p>
          </div>
        </div>
        <div className="lg:w-1/3 md:w-4/12 sm:w-full flex flex-row justify-around items-center">
          <img src={require('../../common/images/drapshop/sshape.svg')} alt="E Shape Art" />
          <div className="text-left">
            <p className="font-bold">S shape</p>
            <p className="text-sm text-gray-500">Means <em>"shop"</em></p>
          </div>
        </div>
      </div>
      <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-center justify-between py-10 px-0">
        <div className="lg:w-1/3 md:w-4/12 sm:w-full flex flex-row justify-center items-center">
          <div className="px-5">
            <img src={require('../../common/images/drapshop/ex1.svg')} alt="Example 1 Art"/>
          </div>
        </div>
        <div className="lg:w-1/3 md:w-4/12 sm:w-full flex flex-row justify-center items-center">
          <div className="px-5">
            <img src={require('../../common/images/drapshop/ex2.svg')} alt="Example 2 Art"/>
          </div>
        </div>
        <div className="lg:w-1/3 md:w-4/12 sm:w-full flex flex-row justify-center items-center">
          <div className="px-5">
            <img src={require('../../common/images/drapshop/ex3.svg')} alt="Example 3 Art"/>
          </div>
        </div>
      </div>
      <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-center justify-between py-10 px-0">
        <div className="lg:w-1/2 md:w-1/2 sm:w-full flex flex-row justify-center items-center">
          <div className="px-5">
            <img src={require('../../common/images/drapshop/font-1.png')} alt="Font Art"/>
          </div>
        </div>
          <div className="lg:w-1/2 md:w-1/2 sm:w-full flex flex-row justify-center items-center">
          <div className="px-5">
            <img src={require('../../common/images/drapshop/font-2.png')} alt="Font Art"/>
          </div>
        </div>
      </div>
      <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-center justify-between py-10 px-0">
        <div className="w-full flex flex-row justify-center items-center">
          <img src={require('../../common/images/drapshop/color-scheme.svg')} alt="Color Scheme Art"/>
        </div>
      </div>
    </div>
  </section>
  )
}

export default Branding
